import React from "react";



const Timeline = () => {
  return (
      <>
    <div className="row home-details-container2 align-items-center">
        <div className="timeline" >
        <img src = 'img/TimeLine.jpg'  />
        </div>
        </div>
        </>
  );
};

export default Timeline;
